import { render, staticRenderFns } from "./PhotoCredit.vue?vue&type=template&id=67a574bc&scoped=true&"
import script from "./PhotoCredit.vue?vue&type=script&lang=js&"
export * from "./PhotoCredit.vue?vue&type=script&lang=js&"
import style0 from "./PhotoCredit.vue?vue&type=style&index=0&id=67a574bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a574bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/pc/Documents/Programs/Vue/top-ten-naija/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMenu } from 'vuetify/lib'
installComponents(component, {VMenu})
